import axiosClient from "./axiosClient";

const endpoint = "/commerce/order-notification-policy";

export const orderNotificationPolicyApi = {
  async get() {
    const response = await axiosClient.get(endpoint, { __silentGenericToast: true });
    return response.data;
  },
  async update(policy) {
    const response = await axiosClient.put(endpoint, policy, {
      __silentGenericToast: true,
    });
    return response.data;
  },
};
